import i18n from '../../locales/i18n'

/**
 * Simple function for toggle cheer.
 * This function just determines if it should be POST or DELETE,
 * sends a request and returns a response
 *
 * @typedef {'events' | 'groups'} EntityType
 * @param {number} id - Id of event or group to cheer
 * @param {EntityType} type - Type of entity
 * @param {bool} userIsCheer - Is user already cheering
 * @return {Object} Promise with response
 */
export const toggleCheer = (id, type, userIsCheer) => {
    let url = `${window.APP_CONFIG.REACT_APP_API_URL}api/cheers`

    if (userIsCheer) {
        url += `?id=${id}&type=${type}`
        return window.axios.delete(url)
    }

    return window.axios.post(url, {
        id,
        type,
    })
}

/**
 * Simple function for hiding email with a specific domains
 *
 * @param {string} email
 * @returns {XML}
 */
export const hideSystemEmail = email => {

    if (email?.includes?.('@privaterelay.appleid.com') !== false) {
        return i18n.t('hiddenEmail.appleID')
    }

    if (email?.includes?.('@sportnect.com') !== false) {
        return ''
    }

    return email
}
